// src/layouts/MainLayout.jsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import AppSidebar from '../components/ui/AppSidebar';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ThemeWrapper from '../components/ThemeWrapper';

export default function MainLayout({
  isSidebarOpen,
  toggleSidebar
}) {
  return (
    <ThemeWrapper>
      <div className="flex h-screen bg-gray-50 dark:bg-gray-900 overflow-hidden">
        <AppSidebar
          isOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
        />
        <div className="flex-1 flex flex-col min-w-0 h-full overflow-hidden relative">
          <Header toggleSidebar={toggleSidebar} />
          <main className="flex-1 bg-gray-50 dark:bg-gray-900 overflow-y-auto overflow-x-hidden p-3 sm:p-4 lg:p-6">
            <div className="max-w-full min-w-0">
              <Outlet />
            </div>
          </main>
          <Footer />
        </div>
      </div>
    </ThemeWrapper>
  );
}
